// @ts-check
import { z } from 'zod';

import Timestamp from '@/store/modules/models/global/Timestamp';

export const TemplateParty = z.object({
  id: z.number(),
  title: z.string(),
  role: z.string(),
  order: z.number(),
  created_at: Timestamp,
  company_id: Timestamp,
});

export const TemplateParties = z.array(TemplateParty);

/** @typedef {z.infer<typeof TemplateParty>} TTemplateParty */
/** @typedef {z.infer<typeof TemplateParties>} TTemplateParties */
